import { useEffect, useRef } from 'react';
import { useRouter } from 'next/router';
import { analytics, initializeAnalytics } from '../../lib/segment';
import { useConsent } from 'hooks/useConsent';

export default function Analytics() {
  const router = useRouter();
  const { hasConsent } = useConsent();
  const isInitialized = useRef(false);

  useEffect(() => {
    if (!router.isReady || !hasConsent || isInitialized.current) {
      return;
    }

    initializeAnalytics();

    isInitialized.current = true;

    const handleRouteChange = () => {
      if (!isInitialized.current) return;
      try {
        analytics.page();
      } catch (error) {
        console.error('Error tracking page view:', error); // fail silently if analytics is not available or fails for some reason
      }
    };

    handleRouteChange();

    router.events.on('routeChangeComplete', handleRouteChange);

    return () => {
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, [router.isReady, hasConsent]);

  return null;
}
